const TEXTS = {
  POWERED: 'Powered by',
  NAME: {
    FIRST: 'Work',
    SECOND: 'Optima',
  },
};

export { TEXTS };
